<template>
  <footer>
    
    <p id="direitos" class="center px-5">
      Todos os direitos reservados à Trilha Cervejaria - Desenvolvido por
      <a
        href="https://www.donuz.com.br/"
        target="_blank"
      >Donuz</a>
    </p>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}

#direitos {
  color: white;
  background-color: black;
  padding-top: 20px;
  padding-bottom: 20px;
  margin: 0;
}

a {
  color: white;
}

</style>
